import type { PropsWithChildren, ReactNode } from 'react';
import { styled } from 'styled-components';

import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import { Text } from '#/components/Text/Text';
import type { Color } from '#/theme/theme';
import { colors, cssBreakpoints } from '#/theme/theme';

import { ChartDetailContainer } from './MainChartDetails.styled';

type ChartDetailProps = {
  iconColor: Color;
  iconName?: IconName;
  tooltip?: ReactNode;
};

export const ChartDetail = styled(
  ({
    iconColor,
    iconName,
    children,
    tooltip,
  }: PropsWithChildren<ChartDetailProps>) => (
    <ChartDetailContainer>
      <Icon
        colorName={iconColor}
        name={iconName ?? 'checkmark-filled'}
        size={27}
      />
      <Text
        style={{
          color: colors.lightContentGrey,
          marginLeft: '10px',
          lineHeight: '24px',
        }}
      >
        {children}
      </Text>
      {tooltip}
    </ChartDetailContainer>
  ),
)`
  align-items: start;
  display: flex;
  flex: 1;
  text-align: left;

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    &:not(:last-of-type) {
      margin-bottom: 0;
      padding-right: 60px;
    }
  }
`;
